import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import cn from 'classnames'

import QRCode from './QRCode'
import useDeviceIdentifiers from '../VNUtil/hooks/useDeviceIdentifiers'

import styles from './QRCodeRegistration.module.scss'
import { setRoute } from '../VNRoutes/ActionCreators'
import VNLoader from '../VNLoader/components/VNLoader'

const QRCodeRegistration = ({ className }) => {
  const classNames = cn(styles.qrCodeRegistration, className)
  const [uuid, setUuid] = useState('')
  const dispatch = useDispatch()
  const { initializeDeviceId, getConditionalDeviceId, getRegistrationUrl } = useDeviceIdentifiers()
  const curDeviceId = getConditionalDeviceId()
  const qrCodeUrl = getRegistrationUrl()

  const onSuccessSetIndentifiers = useCallback(
    (id) => {
      setUuid(id)

      // initial call to device-login with device_id set
      dispatch(setRoute('/device-login'))
    },
    [dispatch],
  )

  useEffect(() => {
    if (!curDeviceId) {
      initializeDeviceId(onSuccessSetIndentifiers)
      return
    }

    setUuid(curDeviceId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!qrCodeUrl) {
    return (
      <div className={styles.loaderContainer}>
        <VNLoader transparent text="Initializing..." />
      </div>
    )
  }

  return (
    <div className={classNames}>
      <div className={styles.container}>
        <div className={styles.qrCodeContainer}>
          <div className={styles.qrCode}>{uuid && <QRCode data={qrCodeUrl} color="black" />}</div>
        </div>
      </div>
      <span className={styles.deviceId}>{uuid}</span>
    </div>
  )
}

export default QRCodeRegistration
